import "../../styles/pageFeedback.css";

function PageFeedback({ type = "info", children, className = "" }) {
  if (!children) return null;

  return (
    <div className={`page-feedback page-feedback--${type} ${className}`.trim()}>
      {children}
    </div>
  );
}

export default PageFeedback;